var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"circle",attrs:{"src":"https://www.xaryxx.com/images/circle.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"names"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(_vm._s(_vm.desc)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2312c5dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/box-title.vue
// module id = null
// module chunks = 